import { LocationOption } from '../types';

interface LocationGridMessageProps {
  locations: LocationOption[];
  onSelect?: (location: LocationOption) => void;
}

function LocationCard({ location }: { location: LocationOption }) {
  return (
    <div className="flex-none snap-center overflow-hidden rounded-lg bg-white border border-gray-100 w-[200px]">
      <button
        className="grid w-full grid-rows-[min-content_auto] text-left"
        onClick={() => {}}
      >
        {location.imgUrl && (
          <div className="h-24 overflow-hidden">
            <img
              src={location.imgUrl}
              alt={location.title}
              className="h-full w-full object-cover"
            />
          </div>
        )}
        <div className="flex flex-col gap-0.5 p-2">
          <div className="font-medium text-sm">{location.title}</div>
          <div className="text-xs text-gray-500">{location.subtitle}</div>
          <div className="mt-1">
            <span className="rounded-full bg-blue-100 px-2 py-0.5 text-xs font-medium text-blue-800">
              {location.label}
            </span>
          </div>
          <div className="mt-0.5 text-xs text-gray-600">{location.description}</div>
        </div>
      </button>
    </div>
  );
}

export function LocationGridMessage({ locations, onSelect }: LocationGridMessageProps) {
  return (
    <div className="flex gap-2">
      {locations.map((location, index) => (
        <div key={index}>
          <LocationCard location={location} />
        </div>
      ))}
    </div>
  );
}
